import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class MergeAddField extends Component {

    constructor() {
        super()
        this.drop = this.drop.bind(this)
        this.allowDrop = this.allowDrop.bind(this)
    }

    allowDrop = (e) => {
        //TODO: Allow to drop only my elements
        e.preventDefault();
    }

    drop = (e) => {
        //TODO: Allow to drop only my elements
        e.preventDefault();
        
        var field = JSON.parse(e.dataTransfer.getData("field"));

        if (this.props.steps.find(a=>a.id === field.id)) {
            //TODO: Use nicer messages
            //alert("This field is already included")
        } else {
            this.props.onSelect(field.id, field.typeId, field.name)
        }
    }


    render() {
        const { t } = this.props;

        return <><br /><div className="drop-target"
            onDrop={this.drop}
            onDragOver={this.allowDrop}   >
            {t("txt_merge_drop")}
        </div>
        </>
    }
}

export default withTranslation()(MergeAddField)